import { Grid } from "@mui/material";
import Templete from "../../template/Template";
import PricingPage from "./PricingPage";

export default function RenewPlan() {
    return(
        <Templete menuActive="license">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PricingPage />
                </Grid>
            </Grid>
        </Templete>
    );
}